import React, { useEffect, useState } from 'react'
import Header2 from '../component/Header2'
import axios from 'axios';
import { toast } from 'react-toastify';
import Footer from '../component/Footer';
import { redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
function Appointment_book() {
  useEffect(() => {
    fetch();
  });
  const [data, setData] = useState([]);
  const fetch = async () => {
    const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/categories_get`);
    setData(res.data);
  };


  const [cate_id, setcate_id] = useState('');
  const [service_id, setservice_id] = useState('');
  const [app_Date, setapp_Date] = useState('');

  const [data1, setData1] = useState([]);
  const changecategories = async (e) => {
    setcate_id(e.target.value);
    const res = await axios.get(
      `https://www.rajvicosmeticclinic.com/RajviApi/services_single_get?id=${e.target.value}`
    );
    setData1(res.data);
  };

  function validation() {
    var ans = true;
    if (cate_id == "") {
      toast.error("Categories Field is required");
      ans = false;
      return false;
    }
    if (service_id == "") {
      toast.error(" Services Field is required");
      ans = false;
      return false;
    }
    if (app_Date == "") {
      toast.error("Appointment Date is required");
      ans = false;
      return false;
    }
    return ans;
  }

  const submithandle = async (i) => {
    i.preventDefault();
    if (validation()) {

      const formData = new FormData();
      formData.append('id', new Date().getTime().toString());
      formData.append('service_id', service_id);
      formData.append('userid', localStorage.getItem('userid'));
      formData.append('app_Date', app_Date);
      formData.append('status', 'Pending');

      if (localStorage.getItem("userid")) {
        const res = await axios.post(`https://www.rajvicosmeticclinic.com/RajviApi/appointment_post`, formData);
        console.log(res);
        if (res.status == 200) {
          toast.success(res.data.message);
          redirect('/');
        }
      }
      else {
        toast.warning("Please Login First Now");
        return false;
      }
    }

  };
  return (
    <>
      <Header2 title='Appointment Book' />
      <div className="row justify-content-center bg-appointment mx-0">
        <div className="col-lg-6 py-5">
          <div
            className="p-5 my-5"
            style={{ background: "rgba(33, 30, 28, 0.7)" }}
          >
            <h1 className="text-white text-center mb-4">
              Make Appointment
            </h1>
            <form
              action=""
              role="form"
              method="post"
              onSubmit={submithandle}
            >
              <div className="form-row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="">Select Categories</label>
                    <select
                      onChange={(e) => changecategories(e)}
                      name="cate_id"
                      className="form-control bg-transparent p-4"
                    >
                      <option value="">Select Categories</option>
                      {(data.length > 0) ? data.map((value) => {
                        console.log(value.cate_name);
                        return (
                          <option value={value.id}>
                            {value.cate_name}
                          </option>
                        );
                      }) : null}
                    </select>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="">Select services</label>
                    <select
                      onChange={(e) => setservice_id(e.target.value)}
                      name="service_id"
                      className="form-control bg-transparent p-4"
                    >
                      <option value="" >Select services</option>
                      {
                        (data1.length > 0) ? data1.map((value) => {
                          return (
                            <option value={value.id}>
                              {value.service_name}
                            </option>
                          );
                        }) : null}
                    </select>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="">Select Date</label>

                    <input
                      type="date"
                      onChange={(e) => setapp_Date(e.target.value)}
                      name="app_Date"
                      className="form-control bg-transparent p-4 datetimepicker-input"
                      placeholder="Select Date"
                      min=""
                    />
                    <div
                      className="date"
                      id="date"
                      name="app_Date"
                      data-target-input="nearest"
                    >
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <button
                    className="btn btn-primary btn-block"
                    type="submit"
                    style={{ height: 47 }}
                  >
                    Make Appointment
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
      <Helmet>

        <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
        <script src="lib/easing/easing.min.js"></script>
        <script src="lib/waypoints/waypoints.min.js"></script>
        <script src="lib/counterup/counterup.min.js"></script>
        <script src="lib/owlcarousel/owl.carousel.min.js"></script>
        <script src="lib/tempusdominus/js/moment.min.js"></script>
        <script src="lib/tempusdominus/js/moment-timezone.min.js"></script>
        <script src="lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js"></script>

        <script src="mail/jqBootstrapValidation.min.js"></script>
        <script src="mail/contact.js"></script>

        <script src="js/main.js"></script>
      </Helmet>
    </>
  )
}

export default Appointment_book
